import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';
import { useSurveyModal } from '../../hooks/use-survey-modal';
interface CTAButtonProps {
  onClick?: () => void;
  className?: string;
  size?: 'default' | 'large';
  text?: string;
}
export function CTAButton({
  onClick,
  className,
  size = 'default',
  text = 'Book a Call'
}: CTAButtonProps) {
  const {
    open
  } = useSurveyModal();
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    open();
  };
  return <div className="flex flex-col items-center gap-2" data-id="element-772">
      <motion.button onClick={handleClick} whileHover={{
      scale: 1.03,
      filter: 'brightness(1.1)'
    }} whileTap={{
      scale: 0.98
    }} className={cn('bg-[#4ECDC4] text-[#1A2B4A] font-bold rounded-xl transition-all duration-200 shadow-lg shadow-[#4ECDC4]/20', size === 'large' ? 'text-xl px-10 py-5' : 'text-lg px-8 py-4', className)} data-id="element-773">
        {text}
      </motion.button>
      <p className="text-sm text-[#4ECDC4]/80 text-center tracking-wide" data-id="element-774">
        Free strategy call · No commitment · Limited availability
      </p>
    </div>;
}
export function CTAButtonLight({
  onClick,
  className,
  size = 'default',
  text = 'Book a Call'
}: CTAButtonProps) {
  const {
    open
  } = useSurveyModal();
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    open();
  };
  return <div className="flex flex-col items-center gap-2" data-id="element-775">
      <motion.button onClick={handleClick} whileHover={{
      scale: 1.03,
      filter: 'brightness(1.05)'
    }} whileTap={{
      scale: 0.98
    }} className={cn('bg-[#4ECDC4] text-[#1A2B4A] font-bold rounded-xl transition-all duration-200 shadow-lg shadow-[#4ECDC4]/30', size === 'large' ? 'text-xl px-10 py-5' : 'text-lg px-8 py-4', className)} data-id="element-776">
        {text}
      </motion.button>
      <p className="text-sm text-white/65 text-center tracking-wide" data-id="element-777">
        Free strategy call · No commitment · Limited availability
      </p>
    </div>;
}